// extracted by mini-css-extract-plugin
export default {"trigger":"kOXGF7tR","root":"JZ7f6Yqh"};